import { trpc } from "@/lib/trpc";

/**
 * The signed-in user's effective role in a project, for hiding actions the
 * API would refuse. Read from `project.getById` (`myRole`), the query
 * `ProjectShell` already loads, so no extra request. It includes implicit
 * owner access for team owners, and is `owner` when the API runs without
 * per-user auth (none / api-key). Until the project loads there are no
 * edit rights, so write actions never flash for viewers.
 */
export function useProjectRole(projectId: string) {
  const { data: project } = trpc.project.getById.useQuery(
    { id: projectId },
    { enabled: !!projectId },
  );
  const role = project?.myRole ?? null;
  return {
    role,
    canEdit: role === "owner" || role === "editor",
    isOwner: role === "owner",
  };
}
